<mat-form-field class="example-chip-list itb-multiselect-chiplist" [ngClass]="{'itb-multiselect-required':isRequired}">
	<mat-chip-list #chipList aria-label="Fruit selection">
		<mat-chip *ngFor="let addedTags of addedTags" [selectable]="selectable" [removable]="removable"
			(removed)="remove(addedTags)" (click)="changeSelected(addedTags)">
			{{ addedTags.tagName || addedTags.name}}
			<!-- <mat-icon  matChipRemove *ngIf="removable">cancel</mat-icon> -->
			<itb-icon matChipRemove *ngIf="removable" [className]="'icon-white cross'" (click)="onRemove()"></itb-icon>
		</mat-chip>
		<div [formGroup]="parentForm" class="input-dropdown">
			<input [required]="isRequired" #trigger="matAutocompleteTrigger" [disabled]="!removable ? true : false"
				placeholder="{{ placeHolder }}" #fruitInput [formControlName]="
					formFieldName !== undefined ? formFieldName : 'formFieldName'
				" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				[matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
		</div>
	</mat-chip-list>
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
		<mat-option *ngFor="let fruit of objectOfTags" [value]="fruit"
			(click)="$event.stopPropagation(); trigger.openPanel()">
			{{ fruit.tagName || fruit.name }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>

<!-- Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->